import { Box, Divider } from '@mui/material';
import { FunctionComponent, ReactElement } from 'react';

const SiteFormDivider: FunctionComponent = (): ReactElement => (
	<Box component={Divider} mt={4} mb={4} />
);

export default SiteFormDivider;
